import React, { createContext, useContext, useState, ReactNode } from "react";

interface UserContextType {
  username: string;
  role: string;
  userId: string;
  serviceLine: string;
  rolename: string;
  isUserLoaded: boolean;
  leaderId: any;
  leaderEntraId: string;
  shareholderEntraID: string;
  leaderName: any;
  setUserInfo: (userInfo: {
    username: string;
    role: string;
    userId: string;
    rolename: string;
    serviceLine: string;
    leaderId: any;
    leaderEntraId: string;
    shareholderEntraID: string;
    leaderName: any;
  }) => void;
}

// Create context with proper default value (cast to type)
const UserContext = createContext<UserContextType>({
  username: "",
  role: "",
  userId: "",
  serviceLine: "",
  rolename: "",
  isUserLoaded: false,
  leaderId: null,
  leaderEntraId: "",
  shareholderEntraID: "",
  leaderName: null,
  setUserInfo: () => {}, // default noop
});

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const [username, setUsername] = useState("");
  const [role, setRole] = useState("");
  const [userId, setUserId] = useState("");
  const [serviceLine, setServiceLine] = useState("");
  const [rolename, setRolename] = useState("");
  const [isUserLoaded, setIsUserLoaded] = useState(false);
  const [leaderId, setLeaderId] = useState(null);
  const [leaderEntraId, setLeaderEntraId] = useState("");
  const [shareholderEntraID, setShareholderEntraID] = useState("");
  const [leaderName, setLeaderName] = useState(null);

  const setUserInfo = ({
    username,
    role,
    userId,
    serviceLine,
    rolename,
    leaderId,
    leaderEntraId,
    shareholderEntraID,
    leaderName,
  }: {
    username: string;
    role: string;
    userId: string;
    serviceLine: string;
    rolename: string;
    leaderId: any;
    leaderName: any;
    leaderEntraId: string;
    shareholderEntraID: string;
  }) => {
    setUsername(username);
    setRole(role);
    setUserId(userId);
    setServiceLine(serviceLine);
    setRolename(rolename);
    setIsUserLoaded(true);
    setLeaderId(leaderId);
    setLeaderEntraId(leaderEntraId);
    setShareholderEntraID(shareholderEntraID);
    setLeaderName(leaderName);
  };

  return (
    <UserContext.Provider
      value={{
        username,
        role,
        userId,
        serviceLine,
        rolename,
        isUserLoaded,
        leaderId,
        leaderName,
        leaderEntraId,
        shareholderEntraID,
        setUserInfo,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for cleaner access
export const useUserContext = () => useContext(UserContext);
